import React from 'react';
import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { getApiHeader } from 'utlis/commonfunctions';
import { ToastContainer, toast } from "react-toastify";
import swal from 'sweetalert';
import Modal from 'react-bootstrap/Modal';
import { ThreeDots } from 'react-loader-spinner'









import Switch from "@mui/material/Switch";
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import SoftInput from "components/SoftInput";
import SoftButton from "components/SoftButton";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "layouts/authentication/components/Footer";
import BillingInformation from "layouts/billing/components/BillingInformation";
import Transactions from "layouts/billing/components/Transactions";


const SERVER_URL = process.env.REACT_APP_API_URL;

const styles = {
  wrapper: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100vw",
    height: "100vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    // backgroundColor: "rgba(255, 255, 255, 0.8)",
    backdropFilter: "blur(1px)",
    zIndex: 9999,
  },
};


function UploadDealerAgreement() {
  const [activeTab, setActiveTab] = useState("pageOne")
  const [currentPage, setCurrentPage] = useState(1);
  const [retailerData, setRetailerData] = useState([])
  const [storeData, setStoreData] = useState([])
  const [rememberMe, setRememberMe] = useState(false);
  const [rememberMe1, setRememberMe1] = useState(false);
  const [allocateBox, setAllocateBox] = useState(false);
  const [retailerBox, setRetailerBox] = useState(false);
  const [modelVisibility, setModelVisibility] = useState(false);
  const [pid, setPid] = useState("");
  const [retailer_code, setRetailer_code] = useState("");
  const [retailerAddress, setRetailerAddress] = useState("")
  const [company, setCompany] = useState("")
  const [name, setName] = useState("")
  const [text, setText] = useState(false)
  const [button, setButton] = useState(false)
  const [selectedSimBaseIds, setSelectedSimBaseIds] = useState([]);
  const [seachStore, setSearchStore] = useState(false)
  const [delearDetails, setDelearDetails] = useState(false)
  const [selectedRetailerId, setSelectedRetailerId] = useState(null);
  const [retailerDetails, setRetailerDetails] = useState(true)
  const [retailer_address_line_1, setRetailer_address_line_1] = useState("")
  const [retailer_address_line_2, setRetailer_address_line_2] = useState("")
  const [retailer_suburb, setRetailer_suburb] = useState("")
  const [retailer_state, setRetailer_state] = useState("")
  const [retailer_post_code, setRetailer_post_code] = useState("")
  const [loading, setLoading] = useState(false);
  const [tableView, setTableView] = useState(false);
  const [disable,setDisable]=useState(false)








  const [formData, setFormData] = useState({
    shop_code: "",
    id_proof: null,
    agreement: null,

  });


  const [error, SetError] = useState({
    id_proof: false,
    agreement: false,

  });
  const [errorMessage, setErrorMessage] = useState({
    id_proof: '',
    agreement: "",

  })








  const handleSearch = async (e) => {
    e.preventDefault();
    const headers = await getApiHeader();

    try {
      const response = await axios.post(`${SERVER_URL}search-retailer`, formData, {
        headers: headers
      });
      if (response.status === 200) {
        setDisable(true)
        setRetailerData(response.data.data)
        const data = response.data.data
        setRetailerBox(true)
        setName(data.retailer_name)
        setCompany(data.retailer_company_name)
        setRetailer_address_line_1(data.retailer_address_line_1)
        setRetailer_address_line_2(data.retailer_address_line_2)
        setRetailer_suburb(data.retailer_suburb)
        setRetailer_state(data.retailer_state)
        setRetailer_post_code(data.retailer_post_code)
        setRetailer_state(data.retailer_state)
        toast.success(response?.data?.message);
      }
      console.log("response", response.data.message);

    } catch (error) {
      console.log(error)
      setDisable(true)
      const errorMessage = error?.response?.data?.message || "An error occurred";
      if (typeof errorMessage === 'object') {
        Object.keys(errorMessage).forEach(key => {
          errorMessage[key].forEach(message => {
            toast.error(message);
          });
        });

      } else {
        toast.error(errorMessage);

      }
    }
  };


  const handleSubmit = async (e) => {
    setLoading(true)
    if (e) {
      e.preventDefault();
    }


    console.log("formData before submit:", formData);

    const formDataToSend = new FormData();
    Object.keys(formData).forEach(key => formDataToSend.append(key, formData[key]));

    const headers = await getApiHeader();
    try {
      const response = await axios.post(`${SERVER_URL}upload-agreement`, formDataToSend, {
        headers: {
          ...headers,
          'Content-Type': 'multipart/form-data',
        },
      });
      if (response.status === 200) {
        const data = response.data.data;
        setRetailerBox(false)
        setLoading(false)
        setFormData({
          shop_code: "",
          id_proof: null,
          agreement: null,

        })
        // Uncomment and update the following lines as necessary
        // setRetailerAddress(data.retailer_address);
        // setCompany(data.retailer_company_name);
        // setName(data.retailer_name);
        // setButton(true);
        // setDelearDetails(true);
        // setRetailerBox(true);
        // setRetailerDetails(true);

        console.log("data", data);
        // toast.success(response?.data?.message);
          let message= response?.data?.message
        swal({
          title: "Success",
          text: message,
          icon: "success",
          button: "Close"
        });
      }
      console.log("response", response.data.message);
    } catch (error) {
      setLoading(false)
      const errorMessage = error?.response?.data?.message || "An error occurred";
      if (typeof errorMessage === 'object') {
        Object.keys(errorMessage).forEach(key => {
          errorMessage[key].forEach(message => {
            SetError(prevError => ({
              ...prevError,
              [key]: true
            }));
            setErrorMessage(prevError => ({
              ...prevError,
              [key]: message
            }));
            // toast.error(message);
          });
        });
      } else {
        toast.error(errorMessage);
        setLoading(false)

      }
    }
  };

  const handleChange = (e) => {
    setDisable(false)
    const { name, value, files } = e.target;
    if (files) {
      setFormData({
        ...formData,
        [name]: files[0],
      });
      SetError({
        ...error,
        [name]: false
      })
    } else {
      setFormData({
        ...formData,
        [name]: value,
      });
    }
  }
















  const handleAllocateBox = (event, simBaseId) => {
    setAllocateBox(true);

    if (event.target.checked) {
      setSelectedSimBaseIds(prevIds => [...prevIds, simBaseId]);
      setFormData(prevFormData => ({
        ...prevFormData,
        sim_base_ids: [...prevFormData.sim_base_ids, simBaseId]
      }));
    } else {
      setSelectedSimBaseIds(prevIds => prevIds.filter(id => id !== simBaseId));
      setFormData(prevFormData => ({
        ...prevFormData,
        sim_base_ids: prevFormData.sim_base_ids.filter(id => id !== simBaseId)
      }));
    }
  };












  useEffect(() => {
    if (selectedRetailerId !== null) {
      handleSubmit();
    }
  }, [formData, selectedRetailerId]);


  function handlefileChange(e) {
    const { name } = e.target;
    const file = e.target.files[0];

    console.log('File:', file);

    if (name === 'id_proof') {
      console.log('Updating id_proof:', file);
      setFormData({
        ...formData,
        id_proof: file
      });
    } else if (name === 'agreement') {
      console.log('Updating agreement:', file);
      setFormData({
        ...formData,
        agreement: file
      });
    }
  }








  return (
    <DashboardLayout>
      <DashboardNavbar />
      <>
        <div>
          <div className="formbold-main-wrapper">
            <div className="formbold-form-wrapper">
              {loading && (
                <div style={styles.wrapper}>
                  <ThreeDots
                    visible={loading}
                    height="80"
                    width="80"
                    color="#C11D6C"
                    radius="9"
                    ariaLabel="three-dots-loading"
                  />
                </div>
              )}


              <h3 style={{ textAlign: "center" }}>Upload ID Proof & Agreement </h3>
              <form action="" method="" onSubmit={handleSearch}>
                <div className="formbold-mb-5 formbold-pt-3">
                  <label className="formbold-form-label formbold-form-label-2">
                  </label>
                  <div className="flex flex-wrap formbold--mx-3 upload-form">
                    <div className="w-full sm:w-half formbold-px-3 ">
                      <div className="formbold-mb-5 ">
                        <label htmlFor="store_name" className="formbold-form-label">
                          Retailer Id <span class="astrix-color">*</span>
                        </label>
                        <input
                          type="text"
                          name="shop_code"
                          id="shop_code"
                          placeholder="Enter Retailer Id"
                          className="formbold-form-input"
                          value={formData.shop_code}
                          onChange={handleChange}
                          autoComplete='off'
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="search-store-buttons">
                  <button className="search-store-button" type="submit" disabled={disable}><i class="fa fa-search"></i> Search</button>
                  {
                    tableView && (
                      <button className="search-store-button"></button>
                    )
                  }
                </div>
              </form>


              
              <div>
                <div classname="formbold-main-wrapper" >

                  {retailerBox && (
                    <div className="container trail trail-wrapper ">
                      <div className="formbold-main-wrapper" style={{ padding: "20px"}}>
                        <SoftBox component="form" role="form" style={{ width: "20%" }} mx={"5%"}>
                          <SoftBox mb={2}>
                            <div className="upload-details">
                            <table class="table table-bordered">
                      <tbody>
                        <tr>
                          <th style={{textAlign:'left', fontSize:'12px'}}>Dealer Name</th>
                          <td style={{textAlign:'left', fontSize:'12px'}}> {name}</td>
                          </tr>
                          <tr>
                            <th style={{textAlign:'left', fontSize:'12px'}}>Company/Store Name</th>
                            <td style={{textAlign:'left', fontSize:'12px'}}> {company}</td>
                          </tr>
                          <tr>
                            <th style={{textAlign:'left', fontSize:'12px'}}>Dealer Address</th>
                            <td style={{textAlign:'left', fontSize:'12px'}}> {retailer_address_line_1} {retailer_address_line_2} {retailer_suburb} {retailer_state} {retailer_post_code}</td>
                          </tr>
                        </tbody>
                      </table>

                              {/* <h4 className='details-name'>Dealer Name: {name}</h4>
                              <h4 className='details-company' >Company/Store Name: {company}</h4>
                              <h4 className='details-address'>Dealer Address:{retailer_address_line_1} {retailer_address_line_2} {retailer_suburb} {retailer_state} {retailer_post_code}</h4> */}
                            </div>
                          </SoftBox>
                        </SoftBox>
                      </div>
                      <div className="row mx-0 justify-content-center ">
                        <div className="col-md-7 col-lg-8 px-lg-8 col-xl-8 px-xl-0 px-xxl-3 ">
                          <form
                            className="w-100 rounded-1 p-4 "
                            encType="multipart/form-data"
                            onSubmit={handleSubmit}
                          >
                            <div>
                            <label className="d-block mb-4">
                              <span className="form-label d-block" style={{ fontSize: "15px", fontWeight: "600"}}> Upload ID Proof <span class="astrix-color">*</span>  </span>
                              <input
                                required=""
                                name="id_proof"
                                type="file"
                                className={error.id_proof ? "form-control form-error" : "form-control"}
                                onChange={handleChange}

                              />
                              <span style={{color:"red" ,fontSize:"12px"}} > Accept: .pdf, .doc, .docx, Max file size 2MB.</span>

                              {error.id_proof && (
                                <p className="error-label">{errorMessage.id_proof} </p>
                              )}
                            </label>


                            <label className="d-block mb-4">
                              <span className="form-label d-block" style={{ fontSize: "15px", fontWeight: "600"}}>Upload Agreement <span class="astrix-color">*</span> </span>
                              <input
                                required=""
                                name="agreement"
                                type="file"
                                className={error.agreement ? "form-control form-error" : "form-control"}
                                onChange={handleChange}
                              />
                                <span style={{color:"red" ,fontSize:"12px"}} > Accept: .pdf, .doc, .docx, Max file size 2MB.</span>
                              {error.agreement && (
                                <p className="error-label">{errorMessage.agreement} </p>
                              )}
                            </label>
                            </div>
                            <div className="search-store-buttons">
                              <button className="search-store-button" type="submit">Upload</button>
                              {
                                tableView && (
                                  <button className="search-store-button"></button>
                                )
                              }
                            </div>
                          </form>
                        </div>
                      </div>
                    </div>
                  )}



                </div>

              </div>
            </div>
          </div>
        </div>
        <style
          dangerouslySetInnerHTML={{
            __html:
              "\n  @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap');\n  * {\n    margin: 0;\n    padding: 0;\n    box-sizing: border-box;\n  }\n  body {\n    font-family: \"Inter\", Arial, Helvetica, sans-serif;\n  }\n  .formbold-mb-5 {\n    margin-bottom: 20px;\n  }\n  .formbold-pt-3 {\n    padding-top: 12px;\n  }\n  .formbold-main-wrapper {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 48px;\n  }\n\n  .formbold-form-wrapper {\n    margin: 0 auto;\n    max-width: 550px;\n    width: 100%;\n    background: white;\n  }\n  .formbold-form-label {\n    display: block;\n    font-weight: 500;\n    font-size: 16px;\n    color: #07074d;\n    margin-bottom: 12px;\n  }\n  .formbold-form-label-2 {\n    font-weight: 600;\n    font-size: 20px;\n    margin-bottom: 20px;\n  }\n\n  .formbold-form-input {\n    width: 100%;\n    padding: 12px 24px;\n    border-radius: 6px;\n    border: 1px solid #e0e0e0;\n    background: white;\n    font-weight: 500;\n    font-size: 16px;\n    color: #6b7280;\n    outline: none;\n    resize: none;\n  }\n  .formbold-form-input:focus {\n    border-color: #6a64f1;\n    box-shadow: 0px 3px 8px rgba(0, 0, 0, 0.05);\n  }\n\n  .formbold-btn {\n    text-align: center;\n    font-size: 16px;\n    border-radius: 6px;\n    padding: 14px 32px;\n    border: none;\n    font-weight: 600;\n    background-color: #6a64f1;\n    color: white;\n    width: 100%;\n    cursor: pointer;\n  }\n  .formbold-btn:hover {\n    box-shadow: 0px 3px 8px rgba(0, 0, 0, 0.05);\n  }\n\n  .formbold--mx-3 {\n    margin-left: -12px;\n    margin-right: -12px;\n  }\n  .formbold-px-3 {\n    padding-left: 12px;\n    padding-right: 12px;\n  }\n  .flex {\n    display: flex;\n  }\n  .flex-wrap {\n    flex-wrap: wrap;\n  }\n  .w-full {\n    width: 100%;\n  }\n  @media (min-width: 540px) {\n    .sm\\:w-half {\n      width: 50%;\n    }\n  }\n"
          }}
        />
        <>
        </>
      </>
    </DashboardLayout>

  )
}
export default UploadDealerAgreement